import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu } from '@mui/material';
import './styles.css';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { MenuList } from '../MenuList';
import { useAuth0 } from '@auth0/auth0-react';

export const Header = () => {
    const { loginWithRedirect, isAuthenticated, logout } = useAuth0();
    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <header className='header-container'>
                <Link to="/"><img src="https://deepid-assets.s3.amazonaws.com/all_images/logo_deepid.png" className="logo" /></Link>
                <div className="menu-container">
                    {
                        isAuthenticated ? (
                            <a className="menu-buttons" onClick={(e) => {
                                e.preventDefault()
                                handleClick(e);
                            }}>
                                <u>
                                    My Account
                                </u>
                                <div className='account-icon'>
                                    <AccountCircleIcon />
                                </div>
                            </a>
                        ) : (
                            <button className="login-button" onClick={() => loginWithRedirect()}>
                                <span className="buttontext-login">Login</span>
                            </button>
                        )
                    }
                </div>
            </header>

            <Menu
                id="account-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'text',
                }}
            >
                <MenuList logout={logout} />
            </Menu>


        </>
    )
}